import o, { css as i } from "styled-components";
const r = {
  sm: "16rem",
  md: "24rem",
  lg: "32rem"
}, e = o.div.withConfig({
  displayName: "Tooltip",
  componentId: "sc-mdcqxu-0"
})(["display:inline-block;.tooltip-arrow{--tooltipBorder:var(--color-bg-strongest);}.tooltip-container{--tooltipBackground:var(--color-bg-strongest);--tooltipColor:var(--color-fg-inverse-default);}"]), d = o.div.withConfig({
  displayName: "TooltipChildren",
  componentId: "sc-mdcqxu-1"
})([""]), l = o.div.withConfig({
  displayName: "TooltipContentArrow",
  componentId: "sc-mdcqxu-2"
})([""]), p = o.div.withConfig({
  displayName: "TooltipContent",
  componentId: "sc-mdcqxu-3"
})(["border:none;border-radius:var(--size-border-radius-md);padding:0.4rem 0.8rem;", ""], ({
  size: t
}) => i(["max-width:", ";"], typeof t == "number" ? `${t}px` : r[t]));
export {
  e as Tooltip,
  d as TooltipChildren,
  p as TooltipContent,
  l as TooltipContentArrow
};
//# sourceMappingURL=style.es.js.map
